import { Component } from "@angular/core";
import { ReportType } from "../shared/models/report-type";
import { Router } from "@angular/router";

@Component({
    templateUrl: './home.component.html',
    styleUrls: [
        './home.component.css'
    ]
})
export class HomeComponent {
    public reportType = ReportType;

    public requestTypes: RequestTypeVm[] = [
        {
            reportType: ReportType.ComprehensiveCaseReview,
            title: 'UCR Comprehensive Review',
            imageUrl: 'images/comprehensive-case-review-report.jpg',
        },
        {
            reportType: ReportType.CausationNecessityReasonableness,
            title: 'Causation Necessity Reports',
            imageUrl: 'images/causation-necessity-reasonableness-report.jpg',
        },
        {
            reportType: ReportType.BasicUCR,
            title: 'Basic UCR Report',
            imageUrl: 'images/basic-ucr-report.jpg',
        },
        {
            reportType: ReportType.BasicMedicare,
            title: 'Basic Medicare Report',
            imageUrl: 'images/basic-medicare-report.jpg',
        },
        {
            reportType: ReportType.BillingSummary,
            title: 'Medical Billing Summary',
            imageUrl: 'images/billing-summary-report.jpg',
        },
        {
            reportType: ReportType.MedicalChronology,
            title: 'Medical Chronology',
            imageUrl: 'images/medical-chronology-report.png',
        },
        {
            reportType: ReportType.BasicCombo,
            title: 'Basic Combo Report',
            imageUrl: 'images/basic-combo-report.jpg',
        },
        {
            reportType: ReportType.MedicalCostProjection,
            title: 'Medical Cost / Project Cost Projection',
            imageUrl: 'images/medical-cost-projection-report.jpg',
        },
        {
            reportType: ReportType.OpposingExpertReportReview,
            title: 'Opposing Expert Report Review',
            imageUrl: 'images/opposing-expert-report-review.jpg',
        }
    ];
}

interface RequestTypeVm {
    reportType: ReportType,
    title: string;
    imageUrl: string;
}
